import {css, Typography, useTheme} from '@mui/material';
import {DlMuiPopper, GetStylesFunction, mixins, useMuiAnchor, utils} from '@wallaby-ui/core';
import * as React from 'react';
import {useIntl} from 'react-intl';

import {MerieSchema} from 'src/js/common/types';
import {TemplatedCellRendererParams} from 'src/js/containers/grid';

type Props = TemplatedCellRendererParams<MerieSchema.components['schemas']['OrganizationSimpleDto']>;

export const ListDepartmentFormatter: React.FC<Props> = (props) => {
  const {value} = props;
  const hasTooltip = !!value;

  const {mouseEventEnter, mouseEventLeave, open, anchorEl} = useMuiAnchor(hasTooltip);
  const theme = useTheme();
  const intl = useIntl();
  const styles = getStyles({theme});
  const translatedLabel = intl && utils.TranslateUtils.translate(value?.shortName ?? '', intl);
  const translatedTitle = intl && utils.TranslateUtils.translate(value?.longName ?? '', intl);

  return (
    <div css={styles.wrapper}>
      <Typography variant={'value'} css={styles.span} onMouseEnter={mouseEventEnter} onMouseLeave={mouseEventLeave}>
        {translatedLabel}
      </Typography>
      <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open}>
        <Typography variant={'popper'}>{translatedTitle}</Typography>
      </DlMuiPopper>
    </div>
  );
};

ListDepartmentFormatter.displayName = 'ListDepartmentFormatter';

const getStyles: GetStylesFunction = (options) => ({
  span: css`
    padding: ${options?.theme?.spacing(1, 0)};
  `,
  wrapper: css`
    ${mixins.dlTextOverflowEllipses};
    min-width: 0;
  `,
});
